"use client";

import React from "react";
import Image from "next/image";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { HardDeadLineIcon } from "@/config/image-config";
import { Button } from "@/components/ui/button";

interface HardDeadlineModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceedToPayment: () => void;
  preventClose?: boolean;
}

const HardDeadlineModal: React.FC<HardDeadlineModalProps> = ({
  isOpen,
  onClose,
  onProceedToPayment,
  preventClose = false,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={preventClose ? undefined : onClose}>
      <DialogContent className="max-w-lg mx-auto p-8">
        <div className="text-center space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-32 h-32 flex items-center justify-center">
              <Image
                src={HardDeadLineIcon}
                alt="Hard Deadline Warning"
                width={130}
                height={130}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          <div>
            <DialogTitle className="text-xl font-semibold leading-tight">
              You have crossed the hard deadline phase.
            </DialogTitle>

            {/* Description */}
            <DialogDescription className="text-muted-foreground text-xs leading-relaxed mt-1">
              You can no longer access this account. Please process for the
              subscription payment to resume using this account.
            </DialogDescription>
          </div>

          {/* Action Button */}
          <Button
            variant="default"
            className="w-full"
            onClick={onProceedToPayment}
          >
            Proceed to payment
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HardDeadlineModal;
